/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  fixDecoderSize,
  fixEncoderSize,
  getBytesDecoder,
  getBytesEncoder,
  getStructDecoder,
  getStructEncoder,
  getU16Decoder,
  getU16Encoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
  type ReadonlyUint8Array,
} from '@solana/kit';

/** Variable-length payload buffer. */
export type PayloadBuf = { len: number; bytes: ReadonlyUint8Array };

export type PayloadBufArgs = PayloadBuf;

export function getPayloadBufEncoder(): FixedSizeEncoder<PayloadBufArgs> {
  return getStructEncoder([
    ['len', getU16Encoder()],
    ['bytes', fixEncoderSize(getBytesEncoder(), 256)],
  ]);
}

export function getPayloadBufDecoder(): FixedSizeDecoder<PayloadBuf> {
  return getStructDecoder([
    ['len', getU16Decoder()],
    ['bytes', fixDecoderSize(getBytesDecoder(), 256)],
  ]);
}

export function getPayloadBufCodec(): FixedSizeCodec<
  PayloadBufArgs,
  PayloadBuf
> {
  return combineCodec(getPayloadBufEncoder(), getPayloadBufDecoder());
}
